interface WistiaPlayerProps {
    video_id: string;
    style?: any;
}

const WistiaPlayer = (props: WistiaPlayerProps) => {
    const { video_id, style = {} } = props;
    // return (
    //     <script src="https://fast.wistia.com/embed/medias/1onaag2iqx.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><span class="wistia_embed wistia_async_1onaag2iqx popover=true popoverAnimateThumbnail=true videoFoam=true" style="display:inline-block;height:100%;position:relative;width:100%">&nbsp;</span></div></div>
    // )
    return (
        <>
            <iframe
                src={`//fast.wistia.net/embed/iframe/${video_id}?videoFoam=true`}
                frameBorder={0}
                className="wistia_embed"
                name="wistia_embed"
                style={{ width: `640px`, height: `360px`, ...style }}
                title={`wistia ${video_id}`}
                data-hj-allow-iframe
            ></iframe>
            <script src="//fast.wistia.net/assets/external/iframe-api-v1.js"></script>
        </>
    );
};

export default WistiaPlayer;
